export default __webpack_public_path__ + "static/media/Physicians Mutual.facb1dff.svg";